module.exports = __webpack_public_path__ + "img/pro3.c593d681.png";